import React from 'react';

import { makeClassNames } from '../../../utils/styles';
import LegendItem, { ILegendItem } from '../../atoms/legend-item/legend-item';
import './legend.scss';

export interface ILegend {
  title?: string;
  items: ILegendItem[];
  dataType?: string;
}

const classNames = () =>
  makeClassNames({
    legend: 'legend',
    legendTitle: 'legend__title',
    legendItems: 'legend__items',
  });

const Legend = ({ title, items, dataType }: ILegend) => {
  const cn = classNames();

  return (
    <div className={cn.legend} data-type={dataType}>
      {title && <div className={cn.legendTitle}>{title}</div>}
      <ul className={cn.legendItems}>
        {items.map((item: ILegendItem, index: number) => (
          <LegendItem {...item} key={index}>
            {/* FIXME key={index}*/}
            {item.children}
          </LegendItem>
        ))}
      </ul>
    </div>
  );
};

export default Legend;
